import {RefSettings, urlImageBase} from "../Models/RefSettings";

function withDefaults(partial: Partial<RefSettings>): RefSettings {
	return Object.assign(new RefSettings(), partial);
}

export const settings: Record<string, RefSettings> = {
	koutravo: withDefaults({
		ref_id: 9,
		bo_showed: true,
	}),
	ladresse: withDefaults({
		ref_id: 10,
		bo_showed: true,
		default_color: "#008890",
		logo_header: urlImageBase + "logo_ladresse.png",
		logo_header_sidebar: urlImageBase + "logo_ladresse_white.png",
		loader: urlImageBase + "loader_ladresse.gif",
		back_url: "https://www.ladresse.com"
	}),
	seloger: withDefaults({
		ref_id: 11,
		default_color: "#e30513",
		width_logo: "150",
		logo_header: urlImageBase + "logo_seloger.png",
		logo_header_sidebar: urlImageBase + "logo_seloger.png",
		loader: urlImageBase + "loader_seloger.gif",
		back_url: "https://www.seloger.com/"
	}),
	lfimmo: withDefaults({
		ref_id: 12,
		default_color: "#af9a6a",
		width_logo: "180",
		logo_header: urlImageBase + "logo_lfimmo.png",
		logo_header_sidebar: urlImageBase + "logo_lfimmo.png",
		loader: urlImageBase + "loader_lfimmo.gif",
		back_url: "https://www.lfimmo.com/"
	}),
	cadastre: withDefaults({
		ref_id: 13,
		back_url: "https://www.cadastre.com/"
	}),
	koutravofree: withDefaults({
		ref_id: 14
	}),
	innovia: withDefaults({
		ref_id: 15,
		bo_showed: true,
		default_color: "#4277fe",
		logo_header: urlImageBase + "logo_innovia.png",
		logo_header_sidebar: urlImageBase + "logo_innovia.png",
		loader: urlImageBase + "loader_innovia.gif"
	}),
	arthurimmo: withDefaults({
		ref_id: 16,
		default_color: "#f29400",
		width_logo: "100%",
		logo_header: urlImageBase + "logo_arthurimmo_bandeau.png",
		logo_header_sidebar: urlImageBase + "logo_arthurimmo.png",
		loader: urlImageBase + "loader_arthurimmo.gif",
		back_url: "https://www.arthurimmo.com/"
	}),
	capifrance: withDefaults({
		ref_id: 17,
		bo_showed: true,
		default_color: "#0093f7",
		width_logo: "160",
		logo_header: urlImageBase + "logo_capifrance.svg",
		logo_header_sidebar: urlImageBase + "logo_capifrance.svg",
		loader: urlImageBase + "loader_innovia.gif",
	}),
	optimhome: withDefaults({
		ref_id: 18,
		bo_showed: true,
		default_color: "#ff5c02",
		width_logo: "160",
		logo_header: urlImageBase + "logo_optimhome.svg",
		logo_header_sidebar: urlImageBase + "logo_optimhome.svg",
		loader: urlImageBase + "loader_optimhome.gif",
	}),
	weinvestagent: withDefaults({
		ref_id: 19,
		bo_showed: true,
		default_color: "#26E0E5",
		logo_header: urlImageBase + "logo_weinvest.svg",
		logo_header_sidebar: urlImageBase + "logo_weinvest_white.svg",
		loader: urlImageBase + "loader_weinvest.gif",
		back_url: "https://weinvest.fr/"
	}),
	weinvestclient: withDefaults({
		ref_id: 20,
		default_color: "#26E0E5",
		logo_header: urlImageBase + "logo_weinvest.svg",
		logo_header_sidebar: urlImageBase + "logo_weinvest_white.svg",
		loader: urlImageBase + "loader_weinvest.gif",
		back_url: "https://weinvest.fr/"
	}),
	loiselet: withDefaults({
		ref_id: 21,
		default_color: "#1D4A85",
		logo_header: urlImageBase + "logo_loiselet_daigremont.png",
		logo_header_sidebar: urlImageBase + "logo_loiselet_daigremont_whitebg.png",
		back_url: "https://www.loiselet-daigremont.com"
	}),
	solalrenov: withDefaults({
		ref_id: 22,
		bo_showed: true,
		default_color: "#fbbc05",
		width_logo: "110",
		logo_header: urlImageBase + "logo_solal_renov.png",
		logo_header_sidebar: urlImageBase + "logo_solal_renov_white.png",
	}),
	agenceplus: withDefaults({
		ref_id: 23,
		back_url: "https://www.agence-plus.fr",
		use_permissions: true
	}),
	laloupeimmo: withDefaults({
		ref_id: 24,
		back_url: "https://la-loupe.immo/",
		use_permissions: true
	}),
	// REF_LIBELLE : Référentiel Koutravo External, REF_NOM_ASSUREUR : Koutravo External, REF_REFERENTIEL : RF25_KTVEX
	ktvexternal: withDefaults({
		ref_id: 25,
		use_permissions: true
	})
};
